import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";

const RegNavOption = () => {
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };
  return (
    <>
      <Nav className="ml-auto" navbar>
        {/* <NavItem className="profile-nav">
                    <NavLink href="/myprofile">View Profile</NavLink>
                  </NavItem> */}
        <NavItem className="register-nav login-nav">
          <NavLink> Already a registered user?</NavLink>
        </NavItem>
        <NavItem className="login-nav">
          <NavLink href="/login" className="btn-support btn-Login">
            Login
          </NavLink>
        </NavItem>
        <NavItem className="temp-login-nav login-nav">
          <NavLink href="/signuplogin" className="btn-support btn-Login">
            Login
          </NavLink>
        </NavItem>
        <NavItem className="logout-nav">
          <NavLink onClick={handleLogout} className="btn-support btn-Logout">
            Logout
          </NavLink>
        </NavItem>
      </Nav>
    </>
  );
};
export default RegNavOption;
